// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/VideoRecorder/style.css
// module id = 3598
// module chunks = 31